import React, { FC } from 'react';
import { Stack } from '@mui/material';

import TalentStatus from '@/components/statuses/TalentStatus/TalentStatus';

interface TalentStatusDisplayProps {
  value?: string;
}

const TalentStatusDisplay: FC<TalentStatusDisplayProps> = ({ value }) => (
  <Stack
    direction="row"
    sx={{
      '& .StatusChipIndicator-general:not(:hover)': {
        bgcolor: 'transparent'
      },
      '& .IndicatorChip-root': {
        textTransform: 'none'
      }
    }}
  >
    {value && <TalentStatus value={value} />}
  </Stack>
);

export default TalentStatusDisplay;
